import React from 'react';
import toWebpImage from '@src/utils/to-webp-image';
import wrapStore from '@src/utils/wrap-store';
import FeatureScreenStore from './store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import SilentVideo from '@src/components/silent-video';
import cx from 'classnames';
import { isTablet } from '@src/utils/common-util';

const styles = require('./index.less');

const FeatureScreen = ({ store }) => {
  store.use();
  return (
    <div className={cx(styles.featureScreenRoot, store.isActive && styles.featureScreenRootAct)}>
      {/* 轮播根容器 */}
      <div className={styles.swiperRoot}>
        <div className={styles.swiperBg} />
        {/* 实际显示内容的轮播层 */}
        <div className={styles.swiperContentBox}>
          <div className={styles.swiperContent}>
            <BaseSwiper store={store.featureSwiperStore}>
              {store.swiperData.map((item, index) => (
                <div key={index} className={styles.swiperItem}>
                  {!isTablet() && (
                    <SilentVideo
                      autoPlay={false}
                      loop={false}
                      className={cx(styles.featureVideo, 'silent-video')}
                      cover={item.swiperImg}
                      src={item.video_url}
                      muted={true}
                    />
                  )}

                  {isTablet() && <img src={item.swiperImg} alt="swiperImg" className={styles.swiperImg} />}
                </div>
              ))}
            </BaseSwiper>
          </div>
        </div>

        {/* 实际触发滑动轮播的轮播层 */}
        <div className={styles.swiperControl}>
          <BaseSwiper store={store.swiperControlStore}>{store.swiperData.map((item, index) => <div key={index} className={styles.swiperItem} />)}</BaseSwiper>
        </div>

        {/* 内容层 */}
        <div className={styles.contentInfo}>
          <div className={styles.swiperDecorate} />
          <img alt="" className={styles.swiperCurrentIndex} src={toWebpImage(require(`./images/num-0${store.swiperActionIndex + 1}.png`))} />
          <div className={styles.moduleTitle} />
          <div className={styles.swiperItemDescGroup}>
            {store.swiperData.map((item, index) => (
              <div
                key={index}
                className={cx(styles.swiperItemDesc, styles[`swiperItemDesc-${index + 1}`], store.swiperActionIndex === index && styles.active)}
                style={{
                  backgroundImage: `url(${item.descriptionImg})`
                }}
              />
            ))}
          </div>
        </div>
        {/* 轮播切换锚点层 */}
        <div className={styles.anchorGroup}>
          <div className={styles.preBt} onClick={store.featureSwiperStore.goPrev} />
          {store.swiperData.map((item, index) => (
            <div
              key={item.title}
              className={cx(styles.anchorItem, styles[`anchorItem${index + 1}`], store.swiperActionIndex === index && styles.active)}
              onClick={() => store.featureSwiperStore.goTo(index)}
            />
          ))}
          <div className={styles.nextBt} onClick={store.featureSwiperStore.goNext} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(FeatureScreen, FeatureScreenStore);
